import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Async } from "react-select";
import * as selectors from "../../reducers";
import "react-select/dist/react-select.css";
import "./search.scss";
import {
    setActiveFeature,
    setActiveProject,
    setSearchBarVisible,
    setSearchedLocation,
} from "../../actions/ui";
import { projectShape } from "../../modules/project";
import pointInPolygon from "@turf/boolean-point-in-polygon";
import turfPoint from "turf-point";
import enhanceWithClickOutside from "react-click-outside";
import PropTypes from "prop-types";

const ESC_KEY = 27;

// New south wales coordinates
const bbox = [143, -38, 154, -28];
const token = process.env.REACT_APP_MAPBOX_API_TOKEN;
const baseUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/{text}.json?country=au&&bbox=${bbox}&access_token=${token}`;
const getUrl = text => {
    return baseUrl.replace("{text}", text.replace(/\s/g, "+"));
};

const getMatchedProjects = (text, projects) => {
    return new Promise((res, rej) => {
        const matchedProjects = projects
            .filter(d => d["Name"].toLowerCase().includes(text.toLowerCase()))
            .map(d => ({
                value: d,
                label: d["Name"],
            }));
        res(matchedProjects);
    });
};
const getMatchedLocations = text => {
    return fetch(getUrl(text))
        .then(res => res.json())
        .then(data => {
            return data.features
                .filter(d => d.context.find(d => d.short_code === "AU-NSW"))
                .map(d => {
                    return {
                        value: {
                            isLocation: true,
                            place_name: d.place_name,
                            center: d.center,
                        },
                        label: d.place_name,
                    };
                });
        });
};

class GeoSearchInput extends Component {
    constructor() {
        super();
        this.getOptions = this.getOptions.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleOnChange(d) {
        if (!d) {
            return;
        }
        const optionPos = d.value.isLocation
            ? d.value.center
            : [d.value.Longitude, d.value.Latitude];
        const activeFeature = this.props.geojson.features.find(feature => {
            return pointInPolygon(turfPoint(optionPos), feature);
        });

        this.props.setActiveFeature(activeFeature);
        this.props.setSearchBarVisible(false);
        if (d.value.isLocation) {
            this.props.setSearchedLocation(optionPos);
        } else {
            this.props.setActiveProject(d.value);
        }
    }
    handleClickOutside() {
        this.props.setSearchBarVisible(false);
    }
    handleKeyDown(event) {
        if (event.keyCode === ESC_KEY) {
            this.props.setSearchBarVisible(false);
        }
    }

    getOptions(text) {
        if (!text || text.length < 2) {
            return Promise.resolve({ options: [] });
        }

        const locationsP = getMatchedLocations(text);
        const projectsP = getMatchedProjects(text, this.props.projects);
        return Promise.all([locationsP, projectsP])
            .then(([locations, projects]) => {
                return {
                    options: projects.concat(locations),
                };
            })
            .catch(err => console.log(err));
    }
    optionsRenderer(option) {
        if (!option) return null;
        if (option.value.isLocation) {
            // TODO they are rendering Suburb in Region. I think we would need a geojson with regions...
            // Leaving for now and hopefully we can get away with just showing the place_name
            return option.label;
        } else {
            return (
                <React.Fragment>
                    <p style={{ margin: "5px 0" }}>{option.label}</p>
                    <strong>Innovation hub: {option.value.hubName}</strong>
                </React.Fragment>
            );
        }
    }
    renderInput() {
        return (
            <Async
                autoFocus
                loadOptions={this.getOptions}
                value={null}
                onChange={this.handleOnChange}
                optionRenderer={this.optionsRenderer}
                filterOptions={o => o}
                placeholder={"Search location or project"}
            />
        );
    }

    render() {
        return (
            <div onKeyPress={this.handleKeyDown} className="Search">
                {this.renderInput()}
                <img
                    className={"searchIcon"}
                    src={`${process.env.PUBLIC_URL}/img/search-icon.svg`}
                    alt="search icon black"
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    projects: selectors.selectFilteredProjects(state),
    geojson: selectors.selectGeoJSON(state),
});
const mapDispatchToProps = {
    setActiveFeature,
    setSearchBarVisible,
    setSearchedLocation,
    setActiveProject,
};

GeoSearchInput.propTypes = {
    setActiveFeature: PropTypes.func.isRequired,
    setActiveProject: PropTypes.func.isRequired,
    setSearchBarVisible: PropTypes.func.isRequired,
    setSearchedLocation: PropTypes.func.isRequired,
    projects: PropTypes.arrayOf(PropTypes.shape(projectShape)),
    geojson: PropTypes.object.isRequired,
};
const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    enhanceWithClickOutside
);
export default enhance(GeoSearchInput);



// WEBPACK FOOTER //
// ./src/components/search/search.js